import { ValidationProvider } from 'vee-validate';
import AGCLabel from '@/components/form/AGCLabel.vue';
import vModelMixin from './v-model';

const agcFormElementMixin = {
  mixins: [vModelMixin],
  components: {
    ValidationProvider,
    AGCLabel,
  },
  props: {
    vid: {
      type: String,
      default: undefined,
    },
    rules: [Object, String],
    name: {
      type: String,
      default: undefined,
    },
    label: {
      type: String,
      default: undefined,
    },
    dateLabel: {
      type: String,
      default: undefined,
    },
    timeLabel: {
      type: String,
      default: undefined,
    },
    subLabel: {
      type: String,
      default: undefined,
    },
    placeholder: {
      type: String,
      default: undefined,
    },
    hasValidState: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    min: {
      type: [String, Number],
    },
    max: {
      type: [String, Number],
    },
    type: {
      type: String,
      default: undefined,
    },
    enableEdit: {
      type: Boolean,
      default: false,
    },
    digits: {
      type: [String, Number],
    },
    inputType: {
      type: String,
      default: 'input',
    },
    fieldName: {
      type: String,
      default: undefined,
    },
    isEditMerchant: {
      type: Boolean,
      default: false,
    },
    customMessages: {
      type: Object,
    },
    mode: {
      type: String,
      default: 'custom',
    },
    validateRegEx: {
      type: RegExp,
    },
  },
  computed: {
    state() {
      return (errors) => {
        if (errors.length > 0) return false;
        if (this.hasValidState) return true;
        return null;
      };
    },
  },
};

export default agcFormElementMixin;
